
import type { BrandBrief } from '../../types';

interface UseProductInfoStepProps {
    sellingPoints: string[];
    keywordsBySite: Record<string, string>;
    onSellingPointsChange: (points: string[]) => void;
    onKeywordsBySiteChange: (keywords: Record<string, string>) => void;
    productName: string;
}

export const useProductInfoStep = ({
    sellingPoints,
    keywordsBySite,
    onSellingPointsChange,
    onKeywordsBySiteChange,
    productName,
}: UseProductInfoStepProps) => {
    // 添加卖点
    const addSellingPoint = () => {
        onSellingPointsChange([...sellingPoints, '']);
    };

    // 更新卖点
    const updateSellingPoint = (index: number, value: string) => {
        const newPoints = [...sellingPoints];
        newPoints[index] = value;
        onSellingPointsChange(newPoints);
    };

    // 删除卖点
    const removeSellingPoint = (index: number) => {
        const newPoints = sellingPoints.filter((_, i) => i !== index);
        onSellingPointsChange(newPoints);
    };

    // 更新站点关键词
    const updateSiteKeywords = (siteCode: string, value: string) => {
        onKeywordsBySiteChange({
            ...keywordsBySite,
            [siteCode]: value,
        });
    };

    // 验证是否可以继续
    const canProceed = productName.trim() && sellingPoints.filter(p => p.trim()).length > 0;

    return {
        addSellingPoint,
        updateSellingPoint,
        removeSellingPoint,
        updateSiteKeywords,
        canProceed,
    };
};
